import demoAsteroide from '../images/demoAsteroide.jpg'

const DemoData = [{
    id: '01',
    name: 'Neowise',
    image: demoAsteroide,
    diameter_max: '3.5812',
    diameter_min: '1.6016',
    potentially_hazardous: false,
    first_observation: "1990-02-04",
    last_observation: "2020-04-28",
    velocity: "15.50"
},
{
    id: '02',
    name: 'Ultima Thule',
    image: demoAsteroide,
    diameter_max: '3.5812',
    diameter_min: '1.6016',
    potentially_hazardous: true,
    first_observation: "1990-02-04",
    last_observation: "2020-04-28",
    velocity: "15.50"
}]

export default DemoData